"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("../../../utilities/utilities");
var MessageBlock_1 = tslib_1.__importDefault(require("../../../view/components/MessageBlock"));
var WidgetBackground = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(MessageBlock_1["default"], { color: "primary" }, utilities_1.__('Začiatok pozadia'))));
};
exports["default"] = react_1["default"].memo(WidgetBackground);
